/* eslint-env browser */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AUSpinnerComponent from '@aarhus-university/au-lib-react-components/build/cjs/spinner';
import FacebookPostComponent from '../components/FacebookPostComponent';
import TwitterStatusComponent from '../components/TwitterStatusComponent';
import labels from '../i18n';
import getFacebook from '../actions/getFacebook';
import getTwitter from '../actions/getTwitter';
import '../styles/styles.scss';

const importer = {
  url: url => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.addEventListener('load', () => resolve(script), false);
    script.addEventListener('error', () => reject(script), false);
    document.body.appendChild(script);
  }),
  urls: urls => Promise.all(urls.map(importer.url)),
};
class AppComponent extends Component {
  static convertDate(d, primaryLang = true) {
    const date = new Date(d);
    const day = date.getDate() < 10 ? (`0${date.getDate()}`) : date.getDate();
    const month = date.getMonth() + 1 < 10 ? (`0${date.getMonth() + 1}`) : (date.getMonth() + 1);
    const hours = date.getHours() < 10 ? (`0${date.getHours()}`) : date.getHours();
    const minutes = date.getMinutes() < 10 ? (`0${date.getMinutes()}`) : date.getMinutes();
    if (primaryLang) {
      return `${day}-${month}-${date.getFullYear()} ${hours}:${minutes}`;
    }
    return `${date.getFullYear()}-${month}-${day} ${hours}:${minutes}`;
  }

  static highlight(text, service) {
    const re = /(#\w[a-zA-ZøæåØÆÅ]+)|(@\w+)|(http|https):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?/g;
    return text.replace(re, (match, p1, p2, p3) => {
      if (typeof p2 !== 'undefined') {
        return `<a class="highlight" href="${service}${match}">${match}</a>`;
      }

      if (typeof p3 !== 'undefined') {
        return `<a class="highlight" href="${match}">${match}</a>`;
      }
      return `<span class="highlight">${match}</span>`;
    });
  }

  render() {
    /* eslint-disable react/no-array-index-key */
    const { social, lang } = this.props;
    const renderFacebook = social.Facebook.Posts.slice(0, 2).map((f, i) => (
      <div key={i} className="column large-3 medium-3 small-12">
        <FacebookPostComponent
          post={f}
          convertDate={AppComponent.convertDate}
          highlight={AppComponent.highlight}
          accessToken={social.Facebook.AccessToken}
        />
      </div>
    ));

    const renderTwitter = social.Twitter.slice(0, 4).map((t, i) => (
      <div key={i} className="column large-3 medium-3 small-12">
        <TwitterStatusComponent
          status={t}
          convertDate={AppComponent.convertDate}
          highlight={AppComponent.highlight}
        />
      </div>
    ));

    return (
      <AUSpinnerComponent
        loaded={social.loaded}
        loadingCondition={!social.loaded}
        onLoad={() => {
          const { actions } = this.props;
          const cachePeriod = 3600;
          const fbAccount = lang === 'da' ? 'UniAarhus' : 'aarhusuni';
          const twAccount = lang === 'da' ? 'aarhusuni' : '';
          actions.getFacebook(cachePeriod, fbAccount, 2);
          if (twAccount !== '') {
            actions.getTwitter(cachePeriod, twAccount, 4);
          }

          setTimeout(() => {
            importer.url('//www.au.dk/fileadmin/res/instashow/jquery.instashow.packaged.js');
          }, 1000);
        }}
      >
        <div className="column large-12 medium-12 small-12">
          <div className="row">
            <div className="column large-6 medium-6 small-12">
              <h1>{labels[lang].AUonSoMe}</h1>
            </div>
            <div className="column large-3 medium-3 small-12">
              <ul className="resetlist tags">
                <li>#AarhusUni</li>
                <li>#Yourniversity</li>
              </ul>
            </div>
            <div className="column large-3 medium-3 small-12">
              <ul className="resetlist follow">
                <li>
                  {labels[lang].followUs}
                  :
                  {' '}
                </li>
                <li className="facebook"><a href={lang === 'da' ? 'https://www.facebook.com/UniAarhus' : 'https://www.facebook.com/aarhusuni'} /></li>
                <li className="twitter"><a href={lang === 'da' ? 'https://twitter.com/AarhusUni' : 'https://twitter.com/StudyAarhusUni'} /></li>
                <li className="instagram"><a href={lang === 'da' ? 'https://www.instagram.com/aarhusuni/?hl=en' : 'https://www.instagram.com/aarhus_university/'} /></li>
                <li className="linkedin"><a href="https://www.linkedin.com/company/aarhus-university-denmark-?trk=hb_tab_compy_id_4648" /></li>
                <li className="youtube"><a href="https://www.youtube.com/user/AarhusUniversity" /></li>
                {(() => {
                  if (lang === 'da') {
                    return <li className="snapchat"><a href="https://snapchat.com/add/aarhusuni" /></li>;
                  }
                  return null;
                })()}
                {(() => {
                  if (lang === 'en') {
                    return <li className="weibo"><a href="https://www.weibo.com/u/6073822649" /></li>;
                  }
                  return null;
                })()}
                {(() => {
                  if (lang === 'en') {
                    return <li className="wechat"><a href="https://international.au.dk/education/meetau/auinmanylanguages/chinese/" /></li>;
                  }
                  return null;
                })()}
              </ul>
            </div>
          </div>
          <div className="row">
            {renderFacebook}
            <div className="column large-6 medium-6 small-12 small">
              <div className="row">
                <div className="column large-12 medium-12 small-12">
                  <div data-is data-is-api="//www.au.dk/fileadmin/res/instashow/api/" data-is-source='["@aarhusuni"]' data-is-cache-media-time="54900" data-is-rows="1" data-is-responsive="%7B%22100%22%3A%7B%22columns%22%3A%224%22%2C%22rows%22%3A%222%22%2C%22gutter%22%3A%220%22%7D%7D" data-is-popup-deep-linking="true" />
                </div>
              </div>
            </div>
          </div>
          <div className="row twitter">
            {renderTwitter}
          </div>
        </div>
      </AUSpinnerComponent>
    );
  }
}

AppComponent.propTypes = {
  actions: PropTypes.shape({
    getFacebook: PropTypes.func.isRequired,
    getTwitter: PropTypes.func.isRequired,
  }).isRequired,
  social: PropTypes.shape({
    Facebook: PropTypes.shape({
      AccessToken: PropTypes.string.isRequired,
      Posts: PropTypes.array.isRequired,
    }).isRequired,
    Twitter: PropTypes.array.isRequired,
    loaded: PropTypes.bool.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const props = {
    social: state.social,
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    getFacebook,
    getTwitter,
  };

  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

AppComponent.displayName = 'AppComponent';
export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);
